import { render } from "./ParalympicEquipmentDetail.vue?vue&type=template&id=7f64180f&scoped=true"
import script from "./ParalympicEquipmentDetail.vue?vue&type=script&lang=js"
export * from "./ParalympicEquipmentDetail.vue?vue&type=script&lang=js"

import "@/components/paralympic/paralympicStore.css?vue&type=style&index=0&id=7f64180f&scoped=true&lang=css&external"
import "./ParalympicEquipmentDetail.vue?vue&type=style&index=1&id=7f64180f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f64180f"]])

export default __exports__